import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-filter-report-columns',
  templateUrl: './filter-report-columns.component.html',
  styleUrls: ['./filter-report-columns.component.scss']
})
export class FilterReportColumnsComponent implements OnInit {
  public title !: string;
  public onClose = new Subject<any>();
  public allReportColumns!: any[];
  public filteredColumns : any = [];
  
  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit(): void {
    this.allReportColumns.forEach((col: any, index) => {
      col['ischecked'] = false;
    })
  }

  public closeModal(data ?: any) {
    this.onClose.next(this.filteredColumns);
    this.bsModalRef.hide();
  }

  public onCheckBoxChange(event: any, column:any){
  console.log(event);
  let colIndex = this.allReportColumns.indexOf(column);
  if(event.target.checked){
    this.filteredColumns.push(column);
    this.allReportColumns[colIndex].ischecked = true;
  } else{
    let index = this.filteredColumns.indexOf(column)
    this.allReportColumns[colIndex].ischecked = false;
    this.filteredColumns.splice(index,1);
  }
  console.log("afterchange", this.filteredColumns.length)
  }

  public onSelectAll(event: any) {
    if (event.target.checked) {
      this.filteredColumns = this.allReportColumns.map((col:any)=> {return col;});
      this.allReportColumns.forEach((col: any, index) => {
        col['ischecked'] = true;
      })
    } else {
      this.filteredColumns = [];
      this.allReportColumns.forEach((col: any, index) => {
        col['ischecked'] = false;
      })
    }
  }

}
